import _ from 'lodash';
import { mapActions } from 'vuex';
import * as types from '@/store/types';

const mixin = {
    created() {
        const mediaQueries = {
            // best practice to use em breakpoints for correct behaviors in safari and matches flexboxgrid
            // 03/17/16 - https://zellwk.com/blog/media-query-units/
            xs: '(max-width: 599px)',
            sm: '(min-width: 600px) and (max-width: 899px)',
            md: '(min-width: 900px) and (max-width: 1199px)',
            lg: '(min-width: 1200px) and (max-width: 1799px)',
            xlg: '(min-width: 1800px)',
        };

        _.forEach(mediaQueries, (query, size) => {
            if (_.isFunction(window.matchMedia)) {
                const sizeQuery = window.matchMedia(query);
                if (sizeQuery.matches) {
                    this.updateScreen(size);
                }
                sizeQuery.addListener((mql) => {
                    if (mql.matches) {
                        this.updateScreen(size);
                    }
                });
            }
        });
    },
    methods: {
        ...mapActions({
            updateScreen: types.SCREEN_SIZE__UPDATE_SCREEN,
        }),
    },
};

export default mixin;
